export const ONEPLAYERUI_CONFIG = {
  DEFAULT_ERROR: 'no player code',
  DEFAULT_NO_CODE_FOUND_ERROR: 'UNKNOWN CODE'
}

export const PLAYER_CONFIG = {
  TERMINAL_MODEL: {
    SAFARI: 'WEB_SAFARI',
    PC: 'WEB_PC'
  },
  PROTOCOL: {
    HLS: 'HLS',
    MSS: 'MSS'
  },
  PLAYER_TYPE: {
    HLSFP: 'HLSFP',
    DASHJS: 'DASHJS'
  },
  SERVICE: {
    VOD: 'ONDEMAND',
    VODLIGHT: 'ONDEMANDLIGHT'
  },
  BACK_BREAKPOINTS: {
    SM_PLUS: 'sm+'
  },
  DRM: {
    KEY_SYSTEM_CHROME: 'com.widevine.alpha',
    PSSH_CHROME: 'AAAARnBzc2gAAAAA7e+LqXnWSs6jyCfc1R0h7QAAACYIARIQ/////////////////////xoMdmlhY2Nlc3NvcmNhKgJTRA==',
    KEY_SYSTEM_APPLE: 'com.apple.fps.1_0',
    VIDEO_ROBUSTNESS: 'SW_SECURE_DECODE',
    AUDIO_ROBUSTNESS: 'SW_SECURE_CRYPTO'
  },
  TIMEOUTS: {
    TIMECODE_DELAY: 120, // delay in seconds, before sending a timecode update
    FLUSH_LAST_PLAYER_ERROR_TIMEOUT: 60000 // delay in ms to auto reload player on error
  }
}

export const METRICS_CONFIG = {
  DEFAULT_ENABLE: false,
  DEFAULT_SERVER_URL: '',
  DEFAULT_SENDING_TIME: '300',
  DEFAULT_EVENTS_FILTER: '50'
}
